<div class="dialog-container">
    <div class="dialog-content">
        <h3 *ngIf="data.title">{{data.title}}</h3>
        <h4>{{data.message}}</h4>
    </div>
    <div class="dialog-actions">
        <ng-container *ngFor="let action of data.actions">
            <div *ngIf="action.color then flat_button; else stroked_button;"></div>
            <ng-template #flat_button>
                <button class="custom-button custom-button-flat" (click)="close(action.result)" [style.background]="action.color" >
                    {{action.text}}
                </button>
            </ng-template>
            <ng-template #stroked_button>
                <button class="default-custom-button custom-button custom-button-stroked" (click)="close(action.result)">
                    {{action.text}}
                </button>
            </ng-template>
        </ng-container>
    </div>
</div>